module.exports = __webpack_public_path__ + "img/sonic-20.fe1510fe.png";